import { Component, OnInit } from '@angular/core';
import { ElementoCarro } from '../../../../model/interface/ElementoCarro';
import { Usuario } from '../../../../model/interface/Usuario';
import { Cotizacion } from '../../../../model/interface/Cotizacion';
import { CarritoService } from '../../../services/carrito/carrito.service';
import { ProductoService } from '../../../services/producto/producto.service';
import { CotizacionService } from '../../../services/cotizacion/cotizacion.service';
import { UsuarioService } from '../../../services/usuario/usuario.service';
import { FormsModule } from '@angular/forms';
import { JsonPipe } from '@angular/common';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from '@angular/router';
import * as _ from 'lodash';

@Component({
  selector: 'app-cotizacion',
  templateUrl: './cotizacion.component.html'
})
export class CotizacionComponent implements OnInit {

  carroProductos: ElementoCarro[] = [];
  yaBuscados: number[] = [];
  cotizacion: any = {
    // 'name': 'María',
    // 'lastname': 'Jaramillo',
    // 'mail': 'm.jaramillo@gmail.com',
    // 'cellphone': '92341234'
  };
  isLoading = false;

  constructor(
    private _carritoService: CarritoService,
    private _productoService: ProductoService,
    private _usuarioService: UsuarioService,
    private _cotizacionService: CotizacionService,
    private router: Router,
    private toastr: ToastsManager,
  ) {}



  ngOnInit() {
    this._carritoService.carroProductos.subscribe(carro => {
      if (carro) {
        this.carroProductos = carro;
        this.mostrarProductosComplementarios();
      }
    } );
  }

  agregarProductoComplementario(padre: ElementoCarro, indexPadre: number, producto: ElementoCarro) {

    this.agregarProductoCotizacion(producto, indexPadre);

    _.remove(padre.productusComplementarios, (prodCom) => {
      return(prodCom.producto.id === producto.producto.id);
    });
  }

  agregarProductoCantidadCotizacion(producto: ElementoCarro, cantidad: number) {

    const clon = _.clone(producto);
    this._carritoService.establecerCantidad(clon, cantidad);
  }

  agregarProductoCotizacion(producto: ElementoCarro, indice?: number) {
    const clon = _.clone(producto);
    this._carritoService.agregarProducto(clon, indice);
  }

  quitarProductoCotizacion(producto: ElementoCarro) {
    const clon = _.clone(producto);
    this._carritoService.quitarProducto(clon);
  }

  eliminarProductoCotizacion(producto: ElementoCarro) {
    const clon = _.clone(producto);
    this._carritoService.eliminarProducto(clon);
  }

  mostrarProductosComplementarios() {
    const params = {'per_page': 2};
    _.each(this.carroProductos, (item: ElementoCarro) => {

      if ((!item.productusComplementarios || item.productusComplementarios.length === 0) && (this.yaBuscados.indexOf(item.producto.id) === -1)) {
        this._productoService.getProductosComplementarios(item.producto.id, params)
          .subscribe( data => {

            // ver que el producto sugerido no sea uno de la lista de productos mostrados

            const nuevosProductos = _.clone(data);
            let conEliminados = 0;

            if (data.length > 0) {
              _.each(data, (producto, indexProducto) => {

                // if (producto) {
                  const indiceEncontrado = _.findIndex(this.carroProductos, (elementoCarro) => {
                    return elementoCarro.producto.id === producto.id;
                  });
                  if (indiceEncontrado >= 0) {
                    nuevosProductos.splice((indexProducto - conEliminados), 1);
                    conEliminados++;
                  }
                  this.yaBuscados.push(producto.id);
                // }
              });

              if (nuevosProductos.length > 0) {
                item.productusComplementarios = this._carritoService.enriquecerProductos(nuevosProductos);
              }
            }
          });
      }

      this.yaBuscados.push(item.producto.id);
    });
  }

  onSubmit() {

    this.isLoading = true;

    const  user: Usuario = {
      'nombre': this.cotizacion.name,
      'apellido': this.cotizacion.lastname,
      'email': this.cotizacion.mail,
      'celular': this.cotizacion.cellphone
    };

    const nuevaCotizacion: Cotizacion = {};

    const codigosProductos: any[] = [];

    _.each(this.carroProductos, (item: ElementoCarro) => {

      if (item.codigo) {
        if (item.cantidad > 0) {
          const aux: any = {};

          aux.codigoId = item.codigo.id;
          aux.cantidad = item.cantidad;
          codigosProductos.push(aux);
        }
      }
    });

    this._usuarioService.create(user)
      .subscribe(resp => {
        this.isLoading = false;

        nuevaCotizacion.clienteId = resp.id;
        nuevaCotizacion.comentarios = this.cotizacion.mesaje;
        nuevaCotizacion.codigosProducotos = codigosProductos;

        this._cotizacionService.create(nuevaCotizacion)
          .subscribe(
            resp => {
              this._carritoService.vaciarCarro();
              this.toastr.success('Su cotización ha sido enviada!');
              this.router.navigate(['/home']);
            }, error => {
              this.isLoading = false;
              this.toastr.error('En estos momentos no podemos atender su solicitud.');
              console.error(error);
            }
          );

      }, error => {
        this.isLoading = false;
        this.toastr.error('En estos momentos no podemos atender su solicitud.');
        console.error(error);
      });
  }

}



// WEBPACK FOOTER //
// /app/src/app/pages/shared/cotizacion/cotizacion.component.ts